import * as React from 'react';
import {
  Box,
  genesisStyled,
  HeadingTwo,
  ThemeProps,
} from '@leagueplatform/genesis-commons';
import { track } from '@leagueplatform/analytics';
import { HealthMetric } from '@leagueplatform/dashboard-api';
import { InsightsCard } from '#components/insights/insights-card/insights-card.tsx';

type MetricGroupProps = {
  title: string;
  metrics: HealthMetric[];
  dataTestId?: string;
  embedded?: boolean;
};

const InsightCardContainer = genesisStyled(Box)`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    grid-gap: ${({ theme }: ThemeProps) => `${theme?.space.one}px`};
    padding-top: ${({ theme }: ThemeProps) => `${theme?.space.one}px`};
    @media screen and (max-width: ${({ theme }: ThemeProps) =>
      theme?.breakpoints.tablet}) {
      grid-template-columns: 1fr;
    }
`;

export function MetricGroup({
  embedded = true,
  title,
  metrics,
  dataTestId,
}: MetricGroupProps) {
  return (
    <div data-testid={dataTestId}>
      <HeadingTwo marginTop="twoAndHalf" marginBottom="oneAndHalf">
        {title}
      </HeadingTwo>
      <InsightCardContainer>
        {metrics.map(({ type, trend, timestamp, unit, value }) => (
          <InsightsCard
            embedded={embedded}
            key={type}
            type={type}
            trend={trend}
            timestamp={timestamp}
            unit={unit}
            value={value}
            onClick={() => {
              track(
                'dashboard.button_clicked.about_me_metrics.navigate_to_metric_item',
                {
                  text_detail: type,
                  content_id: '',
                  contentful_system: '',
                  card_index: '',
                  stack_name: '',
                  metric_id: '',
                  metric_status: '',
                },
              );
            }}
          />
        ))}
      </InsightCardContainer>
    </div>
  );
}
